export default __webpack_public_path__ + "static/media/beats@2x.ea633d03.jpg";